import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

interface MobileMenuProps {
  onNavigate?: () => void;
}

const menus = [
  { id: 1, title: "Accueil", link: "/" },
  { id: 2, title: "À propos", link: "/a-propos" },
  { id: 3, title: "Nos formations", link: "/formations" },
  { id: 4, title: "Méthode pédagogique", link: "/methode-pedagogique" },
  { id: 5, title: "Financement", link: "/financement" },
  { id: 6, title: "Accessibilité", link: "/accessibilite" },
  { id: 7, title: "Contact", link: "/contact" },
];

const MobileMenu: React.FC<MobileMenuProps> = ({ onNavigate }) => (
  <ul className="responsivemenu">
    {menus.map((menu) => (
      <li key={menu.id}>
        <Link to={menu.link} onClick={onNavigate}>
          {menu.title}
        </Link>
      </li>
    ))}
  </ul>
);

export default MobileMenu;
